/**
 * Vuex mutations for the "spaces" (channels) module.
 *
 * Synchronous state writers for channel data, the channel list, and the
 * following-list state. Async work (API calls) lives in operations.js, which
 * commits these mutations with the results.
 */
export default {
  setChannelData(state, data) {
    state.channelData = data;
  },
  setChannelsList(state, data) {
    state.channelsList = data;
  },
  setFollowingList(state, data) {
    state.followingList = data;
  },
  /**
   * Merge one or more channels into `state.followingList` without
   * duplicating entries already present (matched by `id`). Accepts either a
   * single channel object or an array of channels.
   */
  addToFollowingList(state, data) {
    if (Array.isArray(data)) {
      data.forEach(item => {
        if (!state.followingList.some(existing => existing.id === item.id)) {
          state.followingList.push(item);
        }
      });
    } else if (data && !state.followingList.some(existing => existing.id === data.id)) {
      state.followingList.push(data);
    }
  },
  setFollowingCount(state, count) {
    state.followingCount = count;
  },
};
